var catalogueStructure = [
  {
    id: "barnums-tentes",
    name: "BARNUMS & TENTES",
    slug: "barnums-tentes",
    emoji: "\uD83C\uDFAA",
    subcategories: [
      { id: "petit-barnum", name: "Petit Barnum", slug: "petit-barnum", emoji: "\uD83C\uDFAA" },
      { id: "moyen-barnum", name: "Moyen Barnum", slug: "moyen-barnum", emoji: "\uD83C\uDFAA" },
      { id: "grand-barnum", name: "Grand Barnum", slug: "grand-barnum", emoji: "\uD83C\uDFAA" },
      { id: "geant-barnum", name: "G\u00e9ant Barnum", slug: "geant-barnum", emoji: "\uD83C\uDFAA" },
      { id: "tentes-pliantes", name: "Tentes Pliantes raccordables", slug: "tentes-pliantes", emoji: "\uD83C\uDFD5\uFE0F" },
      { id: "parquets", name: "Plancher de R\u00e9ception", slug: "parquets", emoji: "\uD83E\uDEB5" },
    ]
  },
  {
    id: "mobilier-deco",
    name: "MOBILIER - VAISSELLE",
    slug: "mobilier-deco",
    emoji: "\uD83E\uDE91",
    subcategories: [
      { id: "chaises", name: "Chaises et bancs", slug: "chaises", emoji: "\uD83E\uDE91" },
      { id: "tables", name: "Tables et cocktails", slug: "tables", emoji: "\uD83E\uDD42" },
      { id: "vaisselle", name: "Vaisselle", slug: "vaisselle", emoji: "\uD83C\uDF7D\uFE0F" },
      { id: "decoration", name: "D\u00e9coration", slug: "decoration", emoji: "\u2728" },
    ]
  },
  {
    id: "materiel-accessoires",
    name: "ACCESSOIRES - MAT\u00c9RIEL",
    slug: "materiel-accessoires",
    emoji: "\uD83D\uDCA1",
    subcategories: [
      { id: "chauffage", name: "Chauffage", slug: "chauffage", emoji: "\uD83C\uDF21\uFE0F" },
      { id: "eclairage", name: "\u00c9clairage", slug: "eclairage", emoji: "\uD83D\uDCA1" },
      { id: "sonorisation", name: "Sons et Ambiance", slug: "sonorisation", emoji: "\uD83C\uDFB6" },
      { id: "groupe-electrogene", name: "Groupe \u00e9lectrog\u00e8ne", slug: "groupe-electrogene", emoji: "\u26A1" },
    ]
  },
  {
    id: "gonflables-jeux",
    name: "GONFLABLES - JEUX",
    slug: "gonflables-jeux",
    emoji: "\uD83C\uDFF0",
    subcategories: [
      { id: "grandes-structures", name: "Grandes Structures", slug: "grandes-structures", emoji: "\uD83C\uDFA0" },
      { id: "petits-chateaux", name: "Petits Ch\u00e2teaux", slug: "petits-chateaux", emoji: "\uD83C\uDF88" },
      { id: "jeux", name: "Accessoires & Jeux", slug: "jeux", emoji: "\uD83C\uDFBE" },
    ]
  },
  {
    id: "restauration",
    name: "RESTAURATION - BUVETTE",
    slug: "restauration",
    emoji: "\uD83C\uDF7A",
    subcategories: [
      { id: "animations-gourmandes", name: "Animations gourmandes", slug: "animations-gourmandes", emoji: "\uD83C\uDF7F" },
      { id: "tireuses-biere", name: "Tireuses \u00e0 Bi\u00e8re", slug: "tireuses-biere", emoji: "\uD83C\uDF7A" },
      { id: "remorques-frigo-rest", name: "Remorques Frigo", slug: "remorques-frigo", emoji: "\u2744\uFE0F" },
    ]
  },
  {
    id: "pack-tout-inclus",
    name: "PACK TOUT INCLUS",
    slug: "pack-tout-inclus",
    highlight: true,
    emoji: "\uD83C\uDF81",
    subcategories: [
      { id: "packs", name: "Nos Packs", slug: "packs", emoji: "\uD83C\uDF81" },
    ]
  },
];

export default catalogueStructure;
